import PortalAppService from "../../../application/platform/portal-app-service";
import { ACTION_TYPES, useManagementUnitsDispatch } from "./management-units-context";

export const useManagementUnitsController = () => {
    const ManagementUnitsDispatch = useManagementUnitsDispatch();

    async function loadData() {
        try {
            ManagementUnitsDispatch({
                type: ACTION_TYPES.setLoading,
                payload: true,
            });

            const result = await PortalAppService.listManagementUnit();

            ManagementUnitsDispatch({
                type: ACTION_TYPES.setUnits,
                payload: result,
            });
        } catch (error) {
            console.error('Erro ao carregar unidades de gestão:', error);
            ManagementUnitsDispatch({
                type: ACTION_TYPES.setError,
                payload: 'Erro ao carregar as unidades de gestão',
            });
        }
    }

    return {
        loadData
    };
}
